import React, { useState } from 'react';
import DriverActionsMenu from '../actions/DriverActionsMenu';
import { USER_ROLE } from '../../services/auth';

const DriverTable = ({
  drivers,
  handleEdit,
  onDownload,
  onToggleStatus,
  onViewExpenses,
  onViewAttendance,
  onDriverSelected
}) => {
  const u = value => String(value ?? '').toUpperCase();

  const role = localStorage.getItem(USER_ROLE);
  const isAdmin = (role === 'admin');

  const handleViewExpenses = driver => {
    onViewExpenses(driver);
  };

  const handleViewAttendance = driver => {
    onViewAttendance(driver);
  };

  return (
    <div className="hidden md:block relative overflow-visible">
      <table className="min-w-full bg-white table-auto rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr>
            <th className="p-2">Code</th>
            <th className="p-2">Name</th>
            <th className="p-2">Contact</th>
            <th className="p-2">Email</th>
            { isAdmin && <th className="p-2">Branch</th> }
            <th className="p-2">Type</th>
            <th className="p-2">License</th>
            <th className="p-2">Status</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {drivers.length > 0 ? (
            drivers.map((driver, idx) => (
              <tr key={idx} className="border-t">
                <td className="p-2 text-[#E91C24] font-bold">
                  <div className="cursor-pointer" onClick={() => onDriverSelected(driver)}>
                    {u(driver.driver_code)}
                  </div>
                </td>
                <td className="p-2">{u(driver.name)}</td>
                <td className="p-2">{driver.primary_phone}</td>
                <td className="p-2">{u(driver.email)}</td>
                { isAdmin && <td className="p-2">{u(driver?.branch?.name)}</td> }
                <td className="p-2">{u(driver.driver_type)}</td>
                <td className="p-2">{u(driver.licence_number)}</td>
                <td
                  className="p-2 cursor-pointer text-blue-600 hover:underline"
                  onClick={() => onToggleStatus(driver)}
                >
                  {driver.is_active ? 'ACTIVE' : 'INACTIVE'}
                </td>
                <td className="p-2 text-sm">
                  <div className="relative inline-block">
                    <DriverActionsMenu
                      driver={driver}
                      onEdit={() => handleEdit(driver)}
                      onDownload={type => onDownload(driver, type)}
                      onViewExpensesClick={handleViewExpenses}
                      onViewAttendanceClick={handleViewAttendance}
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center text-gray-500 py-10">
                No drivers found. Add one to get started.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DriverTable;
